/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var $ = require('jquery');
var _ = require('underscore');
var bindSmartSwitch = require('./smart-switch.service');
var paymentApi = require('./payment-api.service');
var opTemplateEngine = require('op-template-engine');
var groupService = require('./group.service');
var addOperationOptions = require('./operations.service');
var iframeService = require('./iframe.service');
var submitStyle = require('./submit-button');
var rootScope = require('../services/root-scope.service');
var specialButton = require('./util/special-buttons');
var placeholderSwitch = require('./placeholder-switch.service');
var format = require('./format.service');
var showExactButton = specialButton.showExactButton;
var handleSpecialButton = specialButton.handleSpecialButton;
var inputFitFactory = require('../../vendors/jquery.inputfit');
var loading = require('./loading.service');
var updateSubmitButtonLabel = require('./submit-button').updateSubmitButtonLabel;
const localizeService = require('./localize.service');
const handleError = require('./handle-error.service');

$.fn.inputfit = inputFitFactory; // This add inputfit to jquery

function showOnlyOneDeleteButton(network) {
    //hide all delete-buttons
    $('.delete-account').hide();
    //show the current delete-button
    $('.delete-account-' + network.networkCode).show();
}

/**
 * Handles the selection of a network.
 *
 * @param network Network what is selected
 *                (an instance of applicable or registered network or preset account)
 */
function handleNetworkSelection(network) {
    var formContainer;

    rootScope.setSelectedNetwork(network);
    //if it is the selected display the delete button and hide all others
    showOnlyOneDeleteButton(network);
    formContainer = $('.formContainer:has(#' + network.networkCode + 'form), .formContainer' + network.networkCode);
    $('.formContainer:not(:has(#' + network.networkCode + 'form))').hide();
    updateSubmitButtonLabel(network);
    if (formContainer.attr('initialized')) {
        formContainer.show(rootScope.getAnimationSpeed(), function () {
            !loading.isLoadingState() && submitStyle.disableButtonUneditable(formContainer, network.networkCode);
        });
        showExactButton(formContainer, network);
    } else {
        renderForm(network);
    }
}
function restrictField(field, regEx) {
    if ($(field).length === 0) {
        return null;
    }
    $(field).on('input keydown keyup mousedown mouseup select contextmenu drop', function () {
        if (regEx.test(this.value)) {
            this.oldValue = this.value;
            this.oldSelectionStart = this.selectionStart;
            this.oldSelectionEnd = this.selectionEnd;
        } else if (Object.prototype.hasOwnProperty.call(this, 'oldValue')) {
            this.value = this.oldValue;
            this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
        }
    });
}

function autoChangeFontSize(formContainerSelector) {
    var ibanField = $(formContainerSelector + ' .iban');
    if (ibanField.length < 1) {
        return null;
    }
    ibanField.inputfit({ minSize: 14, maxSize: 16 });
}

function formatCards(formContainerSelector) {
    var cardNumberFieldSelector = formContainerSelector + ' .number';
    var cardNumberField = document.querySelector(cardNumberFieldSelector);
    var ibanFieldSelector = formContainerSelector + ' .iban';
    var ibanField = document.querySelector(ibanFieldSelector);
    var verificationCodeFieldSelector = formContainerSelector + ' .verificationCode';
    if (cardNumberField !== null) {
        format.formatCard(cardNumberField);
    }
    if (ibanField !== null) {
        format.formatIban(ibanField);
    }
    restrictField(verificationCodeFieldSelector, /^[\d]*$/);
}
/**
 * Initializes the form.
 *
 * @param err error to get data from server
 * @param formHTML The form's HTML as a string
 * @param network Selected network object.
 */
function getLocalizedFormCallback(err, formHTML, network) {
    var formId = network.networkCode;
    if (err) {
        specialButton.removeNotAllowed(formId);
        return;
    }
    var replacedHTML = createFormHtml(formHTML, formId);
    var formContainerSelector = '#formContainer' + formId;
    var formContainer = $(formContainerSelector);

    formContainer.append(replacedHTML);
    formContainer.attr('initialized', true);

    // smartSwitch pre-caches all credit card forms, and only the one active should
    // shown
    if (rootScope.getSelectedNetworkCode() == formId) {
        formContainer.show(rootScope.getAnimationSpeed(), function () {
            !loading.isLoadingState() && submitStyle.disableButtonUneditable(formContainer, formId);
        });
    }

    if (rootScope.isSmartSwitch() && groupService.getGroup(network.networkCode, rootScope.getAllNetworks())) {
        bindSmartSwitch(rootScope.getAllNetworks(), rootScope);
    }

    initializeForm(formContainer, network);

    if (!rootScope.isSmartSwitch()) {
        placeholderSwitch.useSpecificPlaceholder(network.networkCode);
    }

    addHint(formContainer);
    autoChangeFontSize(formContainerSelector);
    formatCards(formContainerSelector);
    addOperationOptions(network, formContainer);
}

/**
 * Initializes the form for preload
 *
 * @param err error to get data from server
 * @param formHTML The form's HTML as a string
 * @param network Selected network object.
 */
function getLocalizedFormCallbackForPreload(err, formHTML, network) {
    if (err) {
        // hide the loading if there is an error with loading the file
        // and it is the last in remaining running process
        loading.handleLoadingOnProcessDone();
        return err;
    }
    var formId = network.networkCode;
    var replacedHTML = createFormHtml(formHTML, formId);
    var formContainer = $('#formContainer' + formId);

    formContainer.append(replacedHTML);
    initializeForm(formContainer, network, true);
}

/**
 * Initialize a form with form data.
 *
 * @param formContainer the form node for a network.
 * @param network Network data
 */
function initializeForm(formContainer, network, isPreload) {
    var fieldSet = formContainer.find('fieldset');
    if (fieldSet) {
        var postCreate = fieldSet.attr('postcreate');
        if (typeof window[postCreate] === 'function') {
            var postCreateFunc = eval(postCreate);
            postCreateFunc(network.formData, network);
        }
    }
    handleSpecialButton(formContainer, network, isPreload);
}

/**
 * Adds a hint icon next to the verification code field.
 *
 * @param formContainer The form container element
 */
function addHint(formContainer) {
    var verificationCode = formContainer.find('input[name="verificationCode"]');
    var hintIcon;
    var hintPopup = formContainer.find('.hint');
    if (!hintPopup.length || !verificationCode.length) {
        return;
    }

    hintIcon = $('<span class="hintIcon" tabindex="0" >');
    hintIcon.insertAfter(verificationCode);

    addTouchEvents(hintIcon, hintPopup);

    hintIcon.on('mouseover', function () {
        hintPopup.addClass('hintShown');
    });

    hintIcon.on('mouseleave', function () {
        hintPopup.removeClass('hintShown');
    });

    hintIcon.on('keypress', function (event) {
        if (!event) return;
        event.preventDefault(); // preventing page from scrolling down
        if (typeof event === 'object' && ((event.code && event.code === 'Space') || (event.keyCode && event.keyCode === 32)))
            hintPopup.toggleClass('hintShown');
    });

    hintIcon.on('blur', function () {
        hintPopup.removeClass('hintShown');
    });
}
/**
 * Adds events to hint icon for touch devices.
 *
 * @param hintIcon The hint icon to attach the event to
 * @param hintPopup The hint popup that appears once the hint icon is tapped
 */
function addTouchEvents(hintIcon, hintPopup) {
    hintIcon.on('touchstart', function () {
        hintPopup.toggleClass('hintShown');
    });
}

/**
 * Creates the form HTML by replacing the provided form's HTML ID attribute with a new ID.
 *
 * @param html The form in HTML
 * @param formId The form ID of this HTML snippet
 */
function createFormHtml(html, formId) {
    var isForm = /input|select/.test(html);

    if (isForm) {
        html = '<div class="form" id="' + formId + 'form">' + html + '</div>';
    }

    html = opTemplateEngine(
        html,
        {
            formId: formId,
        },
        '',
        false
    );

    return html;
}

function getPreloadUrl(network) {
    return network && network.links && network.links.preloadForm;
}

function preloadANetwork(network) {
    var preloadUrl = getPreloadUrl(network);
    if (!preloadUrl) {
        return;
    }
    // add a remaining process for loading
    rootScope.aPreloadInProgress();
    rootScope.increaseRemainingProcess();
    paymentApi.getLocalizedForm(preloadUrl, getLocalizedFormCallbackForPreload, network);
}

function preloadSpecialButtons() {
    var networks = rootScope.getAllNetworks();
    _.each(networks, function (groupedNetwork) {
        var network = groupedNetwork[0];
        if (network.networkCode !== rootScope.getSelectedNetworkCode()) {
            preloadANetwork(network);
        }
    });
    if (rootScope.noPreloadNeeded()) {
        loading.hideFullPageLoading();
    }
}

/**
 * Render the form In case of preset
 *
 * @param network The preset PresetAccount
 */
function renderPresetForm(presetAccount) {
    // if summary page, load localizedForm if available
    if (glob.summaryPage && presetAccount.links.localizedForm) {
        paymentApi.getLocalizedForm(presetAccount.links.localizedForm, getLocalizedFormCallback, presetAccount);
        return;
    }
    // localized form is not available
    // or not summary stage
    getLocalizedFormCallback(null, '', presetAccount); //  call the callback without loading any form
    return;
}

/**
 * Render the form.
 *
 * @param network what is selected (an instance of applicable or registered network)
 */
function renderForm(network) {
    // if iframe exist, regardless if preset or not, if summary stage or not
    // loadIframe
    if (network.links.iFrame) {
        iframeService.loadIframeForm(network);
        return;
    }
    if (network.networkCode === 'preset') {
        renderPresetForm(network);
        return;
    }
    localizeService.load(network.links.lang, function (err, translation) {
        if (err) {
            return handleError();
        }
        rootScope.setTranslationObject(network.networkCode, translation);
    });
    // non preset account: could be registered network or applicable network, and not iframe
    if (network.links.localizedForm) {
        paymentApi.getLocalizedForm(network.links.localizedForm, getLocalizedFormCallback, network);
        return;
    }
}

/**
 * Pre-loads other networks in a network group. This is only used when not smartSwitch.
 *
 * @param networks The networks that will be pre-loaded
 */
function preloadGroupedNetworks(networks) {
    // start with 1, since the first network has already been loaded
    for (var i = 1; i < networks.length; i++) {
        if (!$('#' + networks[i].networkCode + 'form').length) {
            renderForm(networks[i]);
        }
    }
}

module.exports = {
    handleNetworkSelection: handleNetworkSelection,
    preloadGroupedNetworks: preloadGroupedNetworks,
    preloadSpecialButtons: preloadSpecialButtons,
};
